import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70312fe3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Animation" }
const _hoisted_2 = {
  viewBox: "0 0 200 200",
  fill: "none",
  class: "Animation__Tiles"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("mask", {
  id: "backbar-tutorial-animation1-mask",
  style: {"mask-type":"alpha"},
  maskUnits: "userSpaceOnUse",
  x: "28",
  y: "28",
  width: "144",
  height: "144"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "28",
    y: "28",
    width: "144",
    height: "144",
    rx: "72",
    fill: "url(#backbar-tutorial-animation1-gradient)"
  })
], -1))
const _hoisted_4 = { mask: "url(#backbar-tutorial-animation1-mask)" }
const _hoisted_5 = { ref: "tiles" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<path class=\"tile\" style=\"opacity:0.2;\" fill=\"white\" d=\"M32,128H8v40h24V128z\" data-v-70312fe3></path><path class=\"tile\" style=\"opacity:0.2;\" fill=\"white\" d=\"M64,128H40v40h24V128z\" data-v-70312fe3></path><path class=\"tile\" style=\"opacity:0.2;\" fill=\"white\" d=\"M96,128H72v40h24V128z\" data-v-70312fe3></path><path class=\"tile\" style=\"opacity:0.2;\" fill=\"white\" d=\"M128,128h-24v40h24V128z\" data-v-70312fe3></path><path class=\"tile\" style=\"opacity:0.2;\" fill=\"white\" d=\"M160,128h-24v40h24V128z\" data-v-70312fe3></path><path class=\"tile\" style=\"opacity:0.2;\" fill=\"white\" d=\"M192,128h-24v40h24V128z\" data-v-70312fe3></path><path class=\"rowTile\" style=\"opacity:0.2;\" fill=\"white\" d=\"M48,80H24v40h24V80z\" data-v-70312fe3></path><path class=\"rowTile\" style=\"opacity:0.2;\" fill=\"white\" d=\"M80,80H56v40h24V80z\" data-v-70312fe3></path>", 8)
const _hoisted_14 = {
  class: "activeTile",
  style: {"opacity":"1"},
  fill: "white",
  d: "M112,80H88v40h24V80z",
  ref: "initialTile"
}
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<path class=\"rowTile\" style=\"opacity:0.2;\" fill=\"white\" d=\"M144,80h-24v40h24V80z\" data-v-70312fe3></path><path class=\"rowTile\" style=\"opacity:0.2;\" fill=\"white\" d=\"M176,80h-24v40h24V80z\" data-v-70312fe3></path><path class=\"tile\" style=\"opacity:0.2;\" fill=\"white\" d=\"M32,32H8v40h24V32z\" data-v-70312fe3></path><path class=\"tile\" style=\"opacity:0.2;\" fill=\"white\" d=\"M64,32H40v40h24V32z\" data-v-70312fe3></path><path class=\"tile\" style=\"opacity:0.2;\" fill=\"white\" d=\"M96,32H72v40h24V32z\" data-v-70312fe3></path><path class=\"tile\" style=\"opacity:0.2;\" fill=\"white\" d=\"M128,32h-24v40h24V32z\" data-v-70312fe3></path><path class=\"tile\" style=\"opacity:0.2;\" fill=\"white\" d=\"M160,32h-24v40h24V32z\" data-v-70312fe3></path>", 7)
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("radialGradient", {
    id: "backbar-tutorial-animation1-gradient",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100 100) rotate(90) scale(72)"
  }, [
    /*#__PURE__*/_createElementVNode("stop"),
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "0.547978",
      "stop-opacity": "0.936405"
    }),
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "1",
      "stop-opacity": "0"
    })
  ])
], -1))
const _hoisted_23 = {
  viewBox: "0 0 200 200",
  class: "Animation__Wave"
}
const _hoisted_24 = ["id"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "0",
  y: "0",
  width: "200",
  height: "200",
  fill: "white"
}, null, -1))
const _hoisted_26 = {
  ref: "mask",
  cx: "100",
  cy: "100",
  r: "100",
  fill: "black"
}
const _hoisted_27 = ["mask"]
const _hoisted_28 = { class: "Animation__Pointer" }
const _hoisted_29 = {
  viewBox: "0 0 33 48",
  ref: "pointer"
}
const _hoisted_30 = {
  ref: "pointerCursor",
  class: "Animation__Pointer__Cursor"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M4.543 37.623c.04.15.02.31-.059.446l-3.464-2a3.412 3.412 0 0 0-.34 2.589l3.863-1.035zm-.274-.358a.59.59 0 0 1 .274.358L.68 38.658a3.41 3.41 0 0 0 1.59 2.071l2-3.464zm11.486 6.632L4.27 37.265l-2 3.464 11.486 6.632 2-3.464zm-.447-.06c.15-.04.311-.019.447.06l-2 3.464a3.411 3.411 0 0 0 2.588.34l-1.035-3.863zm-.357.275a.59.59 0 0 1 .357-.274l1.035 3.864a3.41 3.41 0 0 0 2.072-1.59l-3.464-2zm1.91-3.309-1.91 3.31 3.464 2 1.91-3.31-3.464-2zm3.844-3.3a7.827 7.827 0 0 0-3.832 3.281l3.441 2.038a3.827 3.827 0 0 1 1.874-1.604l-1.483-3.715zm4.229-3.653a8.625 8.625 0 0 1-4.233 3.654l1.491 3.712a12.626 12.626 0 0 0 6.196-5.349l-3.454-2.017zm3.755-6.5-3.76 6.508 3.464 2.001 3.76-6.507-3.464-2.001zm.135-.561a.594.594 0 0 1-.079.47l3.35 2.185c.7-1.072.92-2.388.608-3.63l-3.88.975zm-.291-.376c.145.08.25.216.29.375l3.88-.973a4.593 4.593 0 0 0-2.25-2.912l-1.92 3.51zm-.098-.056.058.033 2-3.464-.058-.034-2 3.465zm-.62-.09c-.018.03-.021-.005.089-.026a.798.798 0 0 1 .53.116l2-3.464c-1.951-1.128-4.772-.876-6.076 1.36l3.456 2.015zm-2.381-3.876-1.08 1.87 3.464 2 1.08-1.87-3.464-2zm-.373-.475c.209.12.313.279.351.389.036.104.003.117.022.086l3.464 2c1.294-2.241.108-4.816-1.837-5.94l-2 3.465zm-.065-.038.065.038 2-3.464-.065-.038-2 3.464zm-.724-.069c.001-.001.003-.005.016-.014a.322.322 0 0 1 .117-.043c.135-.026.352-.011.59.126l2-3.464c-1.991-1.15-4.869-.888-6.187 1.395l3.464 2zm-2.43-3.794-1.034 1.795 3.465 1.998 1.035-1.794-3.465-1.999zm-.002-.269a.49.49 0 0 1-.04.347l3.55 1.843a4.49 4.49 0 0 0 .365-3.18l-3.875.99zm-.201-.284a.49.49 0 0 1 .201.285l3.875-.992c-.273-1.07-.932-2-1.848-2.614l-2.228 3.321zm-.873-.172s.002-.006.02-.017a.369.369 0 0 1 .144-.046c.158-.021.401.013.648.193l2.35-3.237c-2.025-1.47-5.208-1.349-6.626 1.107l3.464 2zm1.959-11.393-5.423 9.393 3.464 2 5.423-9.393-3.465-2zm-.003-1.142c.205.353.205.79.001 1.144l3.467 1.996a5.145 5.145 0 0 0-.005-5.142l-3.462 2.002zm-.99-.573c.408 0 .786.218.99.572l3.464-2A5.145 5.145 0 0 0 21.732.181v4zm-.993.572c.206-.354.584-.572.992-.572l.002-4a5.145 5.145 0 0 0-4.455 2.567l3.461 2.005zm-8.053 13.949L20.741 4.75l-3.464-2-8.055 13.952 3.464 2zm-3.451.37c-.172.057-.25.027-.153.04.08.011.205.042.363.098a4.032 4.032 0 0 1 .528.234c0 .001 0 .001 0 0l-.003-.001-.002-.001-.002-.001s-.001-.001.988-1.74c.99-1.737.99-1.738.989-1.738l-.003-.001-.003-.002-.01-.005a2.974 2.974 0 0 0-.099-.054 8.04 8.04 0 0 0-1.04-.459 5.868 5.868 0 0 0-1.169-.293c-.428-.058-1.024-.08-1.645.126l1.26 3.797zm-4.928 3.22c-.004.023.032-.152.362-.51.308-.336.758-.707 1.315-1.081 1.122-.754 2.434-1.358 3.25-1.63l-1.26-3.796c-1.157.385-2.795 1.148-4.22 2.105-.716.48-1.439 1.051-2.031 1.696-.572.622-1.164 1.468-1.351 2.503l3.935.714zm1.394 10.234c-.357-1.323-.857-3.055-1.194-4.934-.34-1.894-.48-3.756-.2-5.3l-3.936-.712c-.404 2.234-.174 4.644.199 6.72.375 2.09.933 4.025 1.27 5.27L5.7 32.527zm-.21 3.798c.88-1.522.39-3.13.21-3.798L1.84 33.571c.051.19.09.338.117.473.028.132.04.223.043.285.006.108-.014.068.027-.004l3.464 2zM4.484 38.07l1.007-1.744-3.464-2L1.02 36.07l3.464 2zm-1.873.071 1.932-.517-1.932.517zm.658.857 1-1.732-1 1.732zm11.486 6.632-1 1.732 1-1.732zm1.071.14-.517-1.931.517 1.932zm.857-.657-1.732-1 1.732 1zm1.91-3.309-1.72-1.019-.006.01-.006.01 1.732 1zm2.854-2.443.741 1.858.004-.002-.745-1.856zm5.214-4.501 1.727 1.008.004-.008-1.731-1zm3.76-6.508-1.676-1.092-.03.045-.026.047 1.732 1zm.343-2.05-1.94.487 1.94-.486zm-1.271-1.643-1 1.732.02.011.02.012.96-1.755zm-.058-.034 1-1.731-1 1.732zm-3.349.636-1.732-1 3.46 2.008-1.728-1.008zm1.08-1.87-1.732-1 1.732 1zm-1.105-3.206-1 1.732 1-1.732zm-.065-.038-1 1.732 1-1.732zm-3.456.663-1.732-1 3.464 2-1.732-1zm1.035-1.794 1.733.999.022-.038.02-.04-1.775-.921zm.203-1.764 1.938-.495v-.001l-1.938.496zm-1.025-1.45-1.175 1.619.03.021.03.021 1.115-1.66zm-3.72.489-1.731-1 3.464 2-1.732-1zm5.424-9.393 1.732 1v-.002l-1.732-.998zm-.003-3.143-1.732 1 1.732-1zm-2.722-1.572-.001 2v-2zm-2.723 1.57-1.73-1.003-.002.002 1.732 1zm-8.055 13.95-.99 1.739 1.728.983.994-1.721-1.732-1zm-2.35-.528-.63-1.898.63 1.898zM2.34 21.937.372 21.58l1.968.357zm1.43 11.112 1.931-.522-1.93.522zm-.01 2.276 1.731 1-1.732-1zM2.751 37.07l-1.732-1 1.732 1z" }, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "m2.752 37.07 1.007-1.745c.406-.703.223-1.492.012-2.276-.695-2.568-2.115-7.334-1.431-11.112.367-2.027 4.29-4.107 6.265-4.763.897-.298 2.35.529 2.35.529L19.008 3.75a3.146 3.146 0 0 1 5.448 3.146l-5.423 9.393c.682-1.182 2.41-1.44 3.72-.489a2.49 2.49 0 0 1 .821 3.214l-1.035 1.794c.636-1.101 2.178-1.4 3.456-.663l.065.038c1.225.707 1.72 2.142 1.105 3.207l-1.08 1.87c.62-1.063 2.11-1.351 3.349-.637l.058.034a2.593 2.593 0 0 1 .928 3.693l-3.76 6.508a10.625 10.625 0 0 1-5.214 4.501 5.827 5.827 0 0 0-2.854 2.443l-1.91 3.31a1.411 1.411 0 0 1-1.928.516L3.27 38.997a1.41 1.41 0 0 1-.517-1.928z" }, null, -1))
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("g", _hoisted_4, [
        _createElementVNode("g", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("path", _hoisted_14, null, 512),
          _hoisted_15
        ], 512)
      ]),
      _hoisted_22
    ])),
    (_openBlock(), _createElementBlock("svg", _hoisted_23, [
      _createElementVNode("mask", {
        id: 'tutorial-mask--'+_ctx.index
      }, [
        _hoisted_25,
        _createElementVNode("circle", _hoisted_26, null, 512)
      ], 8, _hoisted_24),
      _createElementVNode("circle", {
        ref: "circle",
        cx: "100",
        cy: "100",
        r: "100",
        mask: `url(#tutorial-mask--${_ctx.index})`
      }, null, 8, _hoisted_27)
    ])),
    _createElementVNode("div", _hoisted_28, [
      (_openBlock(), _createElementBlock("svg", _hoisted_29, [
        _createElementVNode("g", _hoisted_30, _hoisted_33, 512)
      ], 512))
    ])
  ]))
}